// ===============================================================
// MGB SCHOOL — DONNÉES DES 12 FORMATIONS
// ===============================================================
// 💳 Paiement en ligne : PayPal / carte bancaire via la page /paiement/:code
//    Tant qu'un lien commence par "REMPLACER_", le bouton "Réserver"
//    affichera un avertissement console.
// ===============================================================

const RAW_FORMATIONS = [
  {
    id: 'F01',
    code: 'F01',
    slug: 'analyse-swot-entrepreneurs',
    emoji: '📊',
    domain: 'Gestion & Stratégie',
    title: 'Analyse SWOT pour entrepreneurs',
    description:
      "Apprenez à diagnostiquer votre entreprise et bâtir un plan d'action stratégique avec la méthode SWOT croisée.",
    duration: '14h / 2j',
    hours: 14,
    price: 490,
    oldPrice: null,
    modality: 'Mixte',
    groupSize: '6-15 pers.',
    badge: null,
    featured: false,
    image:
      'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80',
    points: [
      'Matrice SWOT croisée complète',
      'Objectifs SMART et plan d\'action',
      'Exercices sur votre propre entreprise',
    ],
    objectifs: [
      "Réaliser un diagnostic interne et externe rigoureux de votre activité",
      "Construire une matrice SWOT croisée orientée décisions",
      "Formuler des objectifs SMART alignés avec votre stratégie",
      "Bâtir un plan d'action priorisé sur 90 jours",
      "Mesurer les résultats avec des indicateurs clairs",
    ],
    competences: [
      'Analyser les forces et faiblesses internes de son activité à l\'aide d\'un diagnostic structuré',
      'Évaluer les opportunités et menaces de son environnement concurrentiel (PESTEL, Porter)',
      'Construire une matrice SWOT croisée et en déduire 4 orientations stratégiques',
      'Formuler des objectifs SMART cohérents avec les résultats de l\'analyse',
      'Présenter et défendre ses conclusions stratégiques devant un auditoire professionnel',
    ],
    programme: [
      {
        title: 'Module 1 — Comprendre l\'analyse stratégique',
        duration: '3h',
        items: [
          'Place du SWOT dans la démarche stratégique',
          'Forces, faiblesses, opportunités, menaces : définitions opérationnelles',
          'Collecte d\'informations fiables (PESTEL, 5 forces de Porter)',
        ],
      },
      {
        title: 'Module 2 — Construire votre SWOT',
        duration: '4h',
        items: [
          'Cartographie interne : ressources, compétences, finances',
          'Analyse externe : marché, concurrents, tendances',
          'Atelier pratique sur votre entreprise',
        ],
      },
      {
        title: 'Module 3 — SWOT croisée et décisions',
        duration: '4h',
        items: [
          'Croiser les axes : stratégies offensives, défensives, ajustement, survie',
          'Sélection des priorités à 3-6-12 mois',
          'Études de cas réels',
        ],
      },
      {
        title: 'Module 4 — Plan d\'action et pilotage',
        duration: '3h',
        items: [
          'Définir des objectifs SMART',
          'Construire un plan d\'action à 90 jours',
          'Indicateurs de suivi et tableau de bord',
        ],
      },
    ],
    publicCible: [
      "Chefs d'entreprise TPE/PME",
      "Créateurs et porteurs de projet",
      "Indépendants en repositionnement",
    ],
    prerequis: ["Activité professionnelle ou projet de création en cours"],
  },
  {
    id: 'F02',
    code: 'F02',
    slug: 'marketing-digital-tpe',
    emoji: '📱',
    domain: 'Marketing digital',
    title: 'Marketing digital pour TPE',
    description:
      "Maîtrisez les leviers digitaux essentiels pour développer votre visibilité et acquérir des clients.",
    duration: '21h / 3j',
    hours: 21,
    price: 690,
    oldPrice: null,
    modality: 'Distanciel',
    groupSize: '6-15 pers.',
    badge: null,
    featured: false,
    image:
      'https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?w=800&q=80',
    points: [
      'Stratégie de contenu et calendrier éditorial',
      'Maîtrise Canva, Meta Business, Google My Business',
      'Création de campagnes publicitaires',
    ],
    objectifs: [
      'Définir une stratégie marketing digitale cohérente avec vos objectifs',
      'Produire du contenu engageant avec Canva',
      'Optimiser votre présence sur Google My Business et les réseaux',
      'Lancer des campagnes Meta Ads et Google Ads de base',
      'Analyser vos performances avec des KPI simples',
    ],
    competences: [
      'Analyser son environnement digital et identifier les canaux pertinents pour sa cible',
      'Concevoir une stratégie de contenu adaptée à son secteur et ses ressources',
      'Créer des visuels professionnels et planifier un calendrier éditorial sur 3 mois',
      'Mettre en œuvre une campagne publicitaire ciblée sur les réseaux sociaux',
      'Évaluer la performance de ses actions via des indicateurs clés (KPIs) et ajuster',
    ],
    programme: [
      {
        title: 'Module 1 — Stratégie et positionnement',
        duration: '5h',
        items: [
          'Persona, parcours client, tunnel de conversion',
          'Choix des canaux selon votre cible',
          'Calendrier éditorial mensuel',
        ],
      },
      {
        title: 'Module 2 — Création de contenu avec Canva',
        duration: '5h',
        items: [
          'Bases du design : couleurs, typographies, équilibre',
          'Modèles pour réseaux sociaux et publications',
          'Atelier production de 5 visuels',
        ],
      },
      {
        title: 'Module 3 — Réseaux sociaux & SEO local',
        duration: '6h',
        items: [
          'Meta Business Suite : pages, planification, statistiques',
          'Google My Business : fiche optimisée, avis, photos',
          'Référencement local',
        ],
      },
      {
        title: 'Module 4 — Publicité en ligne',
        duration: '5h',
        items: [
          'Structure d\'un compte publicitaire',
          'Création d\'une campagne Meta Ads pas à pas',
          'Mesure du ROI et optimisations',
        ],
      },
    ],
    publicCible: [
      'Dirigeants de TPE',
      'Indépendants et freelances',
      'Responsables communication',
    ],
    prerequis: ['Aisance avec un ordinateur, navigation web courante'],
  },
  {
    id: 'F03',
    code: 'F03',
    slug: 'creation-activite-ecommerce',
    emoji: '🛒',
    domain: 'Commerce digital',
    title: "Création d'activité e-commerce",
    description:
      'Lancez votre boutique en ligne et réalisez vos premières ventes avec une méthode pas à pas.',
    duration: '28h / 4j',
    hours: 28,
    price: 890,
    oldPrice: null,
    modality: 'Distanciel',
    groupSize: '6-12 pers.',
    badge: null,
    featured: false,
    image:
      'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&q=80',
    points: [
      'Boutique en ligne opérationnelle',
      'Fiches produits SEO et photographie',
      'Plan de lancement et premières ventes',
    ],
    objectifs: [
      'Valider votre offre et votre positionnement e-commerce',
      'Configurer une boutique en ligne (Shopify ou WooCommerce)',
      'Rédiger des fiches produits qui convertissent et se référencent',
      'Mettre en place les moyens de paiement et de livraison',
      'Lancer votre boutique et générer les premières commandes',
    ],
    competences: [
      'Comparer les plateformes e-commerce et sélectionner celle adaptée à son projet',
      'Créer une boutique en ligne fonctionnelle avec catalogue, paiement et livraison configurés',
      'Rédiger des fiches produits optimisées SEO qui convertissent les visiteurs en acheteurs',
      'Mettre en place une stratégie d\'acquisition des premiers clients',
      'Analyser les performances de sa boutique et identifier les leviers d\'optimisation',
    ],
    programme: [
      {
        title: 'Module 1 — Stratégie e-commerce',
        duration: '6h',
        items: [
          'Étude de marché et choix de la niche',
          'Modèles économiques : stock, dropshipping, print-on-demand',
          'Cadre légal e-commerce et CGV',
        ],
      },
      {
        title: 'Module 2 — Création de la boutique',
        duration: '8h',
        items: [
          'Choix de la plateforme (Shopify, WooCommerce, PrestaShop)',
          'Paramétrage : design, navigation, mentions',
          'Paiement, livraison, fiscalité',
        ],
      },
      {
        title: 'Module 3 — Produits et SEO',
        duration: '8h',
        items: [
          'Photographier ses produits avec un smartphone',
          'Rédiger une fiche produit qui vend',
          'Référencement naturel : mots-clés, balises, contenu',
        ],
      },
      {
        title: 'Module 4 — Lancement et acquisition',
        duration: '6h',
        items: [
          'Plan de lancement 30 jours',
          'Acquisition organique et payante',
          'Service client et fidélisation',
        ],
      },
    ],
    publicCible: [
      'Créateurs de boutiques en ligne',
      'Artisans souhaitant vendre en ligne',
      'Dirigeants TPE en transformation digitale',
    ],
    prerequis: ['Idée de produit ou catalogue, aisance avec un ordinateur'],
  },
  {
    id: 'F04',
    code: 'F04',
    slug: 'gestion-administrative-microentreprise',
    emoji: '📋',
    domain: 'Gestion administrative',
    title: "Gestion administrative d'une microentreprise",
    description:
      "Sécurisez la gestion administrative quotidienne de votre microentreprise et anticipez les évolutions.",
    duration: '14h / 2j',
    hours: 14,
    price: 390,
    oldPrice: null,
    modality: 'Mixte',
    groupSize: '6-15 pers.',
    badge: null,
    featured: false,
    image:
      'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80',
    points: [
      'Obligations URSSAF et déclarations',
      'Facturation conforme',
      'Anticiper seuils et évolutions de statut',
    ],
    objectifs: [
      'Comprendre le régime fiscal et social de la microentreprise',
      'Maîtriser les obligations déclaratives URSSAF',
      'Établir une facturation conforme à la réglementation',
      "Anticiper les seuils et préparer un éventuel changement de statut",
      'Organiser un suivi administratif efficace',
    ],
    competences: [
      'Identifier l\'ensemble des obligations déclaratives et comptables du régime microentrepreneur',
      'Appliquer les règles de facturation et tenir son livre de recettes conformément à la législation',
      'Calculer ses cotisations sociales selon son activité et son chiffre d\'affaires',
      'Utiliser le portail URSSAF pour effectuer ses déclarations en ligne',
      'Anticiper les seuils de chiffre d\'affaires et planifier l\'évolution de son statut',
    ],
    programme: [
      {
        title: 'Module 1 — Cadre légal et fiscal',
        duration: '3h',
        items: [
          'Statut de la microentreprise : avantages et limites',
          'Plafonds de chiffre d\'affaires et seuils',
          'Versement libératoire et options fiscales',
        ],
      },
      {
        title: 'Module 2 — Obligations URSSAF',
        duration: '4h',
        items: [
          'Déclaration mensuelle ou trimestrielle de CA',
          'Calcul des cotisations sociales',
          'CFE et taxes locales',
        ],
      },
      {
        title: 'Module 3 — Facturation et comptabilité',
        duration: '4h',
        items: [
          'Mentions obligatoires d\'une facture',
          'Livre des recettes et registre des achats',
          'Outils de facturation : Henrri, Tiime, Excel',
        ],
      },
      {
        title: 'Module 4 — Anticiper et évoluer',
        duration: '3h',
        items: [
          'Quand passer en société (EI, EURL, SASU) ?',
          'TVA : franchise en base et passage en redevable',
          'Plan de pilotage administratif annuel',
        ],
      },
    ],
    publicCible: [
      'Microentrepreneurs en activité',
      'Porteurs de projet souhaitant créer une microentreprise',
      "Salariés envisageant une activité complémentaire",
    ],
    prerequis: ['Aucun prérequis spécifique'],
  },
  {
    id: 'F05',
    code: 'F05',
    slug: 'lecture-securisation-contrat-travail',
    emoji: '⚖️',
    domain: 'Droit du travail',
    title: "Lecture et sécurisation d'un contrat de travail",
    description:
      'Analysez et sécurisez vos contrats de travail pour prévenir les contentieux.',
    duration: '14h / 2j',
    hours: 14,
    price: 490,
    oldPrice: null,
    modality: 'Mixte',
    groupSize: '6-15 pers.',
    badge: null,
    featured: false,
    image:
      'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800&q=80',
    points: [
      'Analyse de contrats réels',
      'Identification des clauses à risque',
      'Maîtrise des procédures de rupture',
    ],
    objectifs: [
      'Connaître les différents types de contrats et leur cadre légal',
      "Identifier les clauses essentielles et les clauses à risque",
      "Sécuriser la rédaction et les avenants",
      'Maîtriser les principales procédures de rupture',
      'Limiter les risques de contentieux prud\'homaux',
    ],
    competences: [
      'Identifier les mentions obligatoires et clauses spéciales d\'un contrat de travail',
      'Distinguer les différents types de contrats (CDI, CDD, intérim) et leurs implications',
      'Analyser une clause de non-concurrence, de mobilité ou de confidentialité et évaluer sa légalité',
      'Appliquer la procédure de rupture conventionnelle ou de licenciement conformément au droit',
      'Évaluer les risques juridiques d\'un contrat et identifier les recours disponibles',
    ],
    programme: [
      {
        title: 'Module 1 — Le contrat de travail : cadre général',
        duration: '3h',
        items: [
          'CDI, CDD, intérim, alternance : différences clés',
          'Période d\'essai, durée du travail, rémunération',
          'Hiérarchie des normes : Code, convention, contrat',
        ],
      },
      {
        title: 'Module 2 — Clauses essentielles',
        duration: '4h',
        items: [
          'Clauses obligatoires et facultatives',
          'Clauses sensibles : non-concurrence, mobilité, exclusivité',
          'Atelier d\'analyse sur contrats réels',
        ],
      },
      {
        title: 'Module 3 — Vie du contrat',
        duration: '4h',
        items: [
          'Modification du contrat vs simple changement',
          'Rédaction d\'avenants',
          'Suspension : maladie, congés, parental',
        ],
      },
      {
        title: 'Module 4 — Rupture du contrat',
        duration: '3h',
        items: [
          'Démission, rupture conventionnelle, licenciement',
          'Procédure pas à pas et délais',
          'Risques prud\'homaux et bonnes pratiques',
        ],
      },
    ],
    publicCible: [
      'Dirigeants TPE/PME',
      'Responsables RH et assistants RH',
      'Encadrants et managers',
    ],
    prerequis: ['Notions de base en gestion d\'équipe'],
  },
  {
    id: 'F06',
    code: 'F06',
    slug: 'communication-professionnelle-numerique',
    emoji: '💬',
    domain: 'Communication',
    title: 'Communication professionnelle numérique',
    description:
      'Communiquez efficacement par e-mail et via les outils collaboratifs numériques.',
    duration: '21h / 3j',
    hours: 21,
    price: 590,
    oldPrice: null,
    modality: 'Distanciel',
    groupSize: '6-15 pers.',
    badge: null,
    featured: false,
    image:
      'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=800&q=80',
    points: [
      'E-mails professionnels impactants',
      'Maîtrise Teams, Slack, Google Workspace',
      'Optimisation profil LinkedIn',
    ],
    objectifs: [
      'Rédiger des e-mails professionnels clairs et efficaces',
      'Utiliser les outils collaboratifs au quotidien (Teams, Slack)',
      'Organiser ses documents avec Google Workspace ou Microsoft 365',
      'Optimiser son profil LinkedIn et sa marque personnelle',
      "Adopter les bonnes pratiques de communication asynchrone",
    ],
    competences: [
      'Identifier les codes et usages de la communication professionnelle en contexte numérique',
      'Rédiger des e-mails, comptes rendus et messages professionnels adaptés à chaque interlocuteur',
      'Utiliser les outils collaboratifs (Teams, Slack, Google Workspace) dans un contexte professionnel',
      'Gérer et valoriser son image professionnelle sur les réseaux numériques (LinkedIn)',
      'Adapter son registre de communication et gérer un conflit ou une crise par voie numérique',
    ],
    programme: [
      {
        title: 'Module 1 — E-mail professionnel',
        duration: '5h',
        items: [
          'Structure d\'un e-mail percutant',
          'Ton, formules, signature',
          'Gestion des e-mails complexes (relances, refus, négociation)',
        ],
      },
      {
        title: 'Module 2 — Outils collaboratifs',
        duration: '6h',
        items: [
          'Microsoft Teams : canaux, réunions, fichiers',
          'Slack : channels, threads, intégrations',
          'Bonnes pratiques d\'usage en équipe',
        ],
      },
      {
        title: 'Module 3 — Productivité avec Workspace',
        duration: '5h',
        items: [
          'Google Drive / OneDrive : organisation et partage',
          'Documents collaboratifs en temps réel',
          'Calendrier partagé et planification',
        ],
      },
      {
        title: 'Module 4 — LinkedIn et image professionnelle',
        duration: '5h',
        items: [
          'Optimiser son profil LinkedIn',
          'Publier du contenu engageant',
          'Réseautage professionnel actif',
        ],
      },
    ],
    publicCible: [
      'Salariés en reconversion',
      'Demandeurs d\'emploi en insertion',
      'Indépendants souhaitant moderniser leur communication',
    ],
    prerequis: ['Aisance de base avec un ordinateur et le web'],
  },
  {
    id: 'F07',
    code: 'F07',
    slug: 'gestion-stocks-logistique',
    emoji: '📦',
    domain: 'Logistique',
    title: 'Gestion des stocks et logistique',
    description:
      "Optimisez vos stocks et fiabilisez votre chaîne logistique avec des méthodes éprouvées.",
    duration: '21h / 3j',
    hours: 21,
    price: 690,
    oldPrice: null,
    modality: 'Mixte',
    groupSize: '6-15 pers.',
    badge: null,
    featured: false,
    image:
      'https://images.unsplash.com/photo-1553413077-190dd305871c?w=800&q=80',
    points: [
      'Méthodes ABC, FIFO, LIFO',
      'Calcul stock de sécurité et point de commande',
      'Tableau de bord logistique',
    ],
    objectifs: [
      'Comprendre les enjeux financiers liés aux stocks',
      'Appliquer les méthodes ABC, FIFO et LIFO',
      'Calculer un stock de sécurité et un point de commande',
      'Suivre les indicateurs logistiques clés',
      'Mettre en place un tableau de bord opérationnel',
    ],
    competences: [
      'Identifier les différents types de coûts logistiques et leur impact sur la rentabilité',
      'Appliquer les méthodes ABC, FIFO et LIFO à la gestion de ses propres stocks',
      'Calculer le stock de sécurité, le point de commande et la quantité économique de commande',
      'Mettre en place un tableau de bord logistique avec les KPIs pertinents',
      'Évaluer et sélectionner ses prestataires logistiques selon des critères objectifs',
    ],
    programme: [
      {
        title: 'Module 1 — Fondamentaux de la gestion des stocks',
        duration: '5h',
        items: [
          'Vocabulaire : stock physique, comptable, en transit',
          'Coûts cachés du stock',
          'Cycle d\'approvisionnement',
        ],
      },
      {
        title: 'Module 2 — Méthodes de gestion',
        duration: '6h',
        items: [
          'Classification ABC : 20/80 appliqué aux stocks',
          'Méthodes de valorisation : FIFO, LIFO, CMP',
          'Inventaire tournant vs annuel',
        ],
      },
      {
        title: 'Module 3 — Optimisation et calculs',
        duration: '5h',
        items: [
          'Stock de sécurité et point de commande',
          'Quantité économique de commande (formule de Wilson)',
          'Cas pratiques sur tableur',
        ],
      },
      {
        title: 'Module 4 — Pilotage et tableau de bord',
        duration: '5h',
        items: [
          'KPI : taux de rotation, taux de service, taux de rupture',
          'Construction d\'un tableau de bord',
          'Plan d\'amélioration continue',
        ],
      },
    ],
    publicCible: [
      'Responsables logistique et magasin',
      'Dirigeants TPE/PME e-commerce ou retail',
      'Acheteurs et approvisionneurs',
    ],
    prerequis: ['Notions de base d\'Excel ou Google Sheets'],
  },
  {
    id: 'F08',
    code: 'F08',
    slug: 'outils-ia-entreprises',
    emoji: '🤖',
    domain: 'Intelligence Artificielle',
    title: 'Outils IA pour entreprises',
    description:
      "Adoptez l'IA générative et l'automatisation pour gagner en productivité dans votre activité.",
    duration: '14h / 2j',
    hours: 14,
    price: 490,
    oldPrice: null,
    modality: 'Distanciel',
    groupSize: '6-15 pers.',
    badge: 'NOUVEAUTÉ',
    featured: false,
    image:
      'https://images.unsplash.com/photo-1677442135703-1787eea5ce01?w=800&q=80',
    points: [
      'Prompting avancé pour votre métier',
      'Automatisation no-code Zapier, Make',
      "Plan de déploiement IA 90 jours",
    ],
    objectifs: [
      "Comprendre les usages concrets de l'IA pour votre métier",
      'Maîtriser le prompting pour ChatGPT, Claude, Gemini',
      'Automatiser des tâches répétitives avec Zapier ou Make',
      'Identifier les cas d\'usage à forte valeur ajoutée',
      "Élaborer un plan de déploiement IA sur 90 jours",
    ],
    competences: [
      'Expliquer le fonctionnement des LLMs et identifier les familles d\'outils IA disponibles en 2026',
      'Utiliser les assistants IA (ChatGPT, Claude, Gemini) avec des techniques de prompting avancées',
      'Créer des workflows automatisés intégrant l\'IA dans ses processus professionnels',
      'Produire des contenus professionnels assistés par l\'IA (textes, visuels, présentations)',
      'Construire et présenter un plan de déploiement IA concret pour son activité',
    ],
    programme: [
      {
        title: 'Module 1 — Panorama de l\'IA en entreprise',
        duration: '3h',
        items: [
          'Familles d\'IA et limites actuelles',
          'Cartographie des outils du marché',
          'Risques, RGPD et confidentialité',
        ],
      },
      {
        title: 'Module 2 — Maîtriser le prompting',
        duration: '4h',
        items: [
          'Structure d\'un prompt efficace',
          'Templates pour vente, RH, communication, support',
          'Prompts chaînés et personas',
        ],
      },
      {
        title: 'Module 3 — Automatiser sans coder',
        duration: '4h',
        items: [
          'Introduction à Zapier et Make',
          'Connecter ses outils : e-mail, CRM, tableurs',
          'Atelier création d\'un workflow réel',
        ],
      },
      {
        title: 'Module 4 — Plan de déploiement',
        duration: '3h',
        items: [
          'Identifier les cas d\'usage à fort ROI',
          'Roadmap 30/60/90 jours',
          'Suivi des gains de productivité',
        ],
      },
    ],
    publicCible: [
      'Dirigeants et managers TPE/PME',
      'Indépendants et freelances',
      'Responsables marketing, RH, opérations',
    ],
    prerequis: ['Aisance avec un ordinateur et le web'],
  },
  {
    id: 'F09',
    code: 'F09',
    slug: 'elements-cles-contrat-travail',
    emoji: '📝',
    domain: 'Droit du travail',
    title: "Identifier les éléments clés d'un contrat de travail",
    description:
      'Formation phare MGB School : maîtrisez les fondamentaux du contrat de travail.',
    duration: '14h / 2j',
    hours: 14,
    price: 250,
    oldPrice: null,
    modality: 'Mixte',
    groupSize: '8-12 pers.',
    badge: 'FORMATION PHARE',
    featured: true,
    image:
      'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800&q=80',
    points: [
      'Analyse de vrais contrats',
      'Fiches mémo incluses',
      'Identification des clauses à risque',
    ],
    objectifs: [
      'Identifier rapidement les clauses essentielles d\'un contrat',
      'Repérer les clauses à risque et les pièges courants',
      'Sécuriser vos pratiques RH au quotidien',
      'Utiliser des fiches mémo opérationnelles',
      'Échanger autour de cas concrets',
    ],
    competences: [
      'Identifier les mentions obligatoires d\'un contrat de travail selon le type de contrat',
      'Distinguer les différents types de contrats (CDI, CDD, temps partiel) et leurs spécificités',
      'Analyser les clauses spéciales (non-concurrence, mobilité, confidentialité) et évaluer leur portée',
      'Repérer les clauses potentiellement abusives ou contraires à la loi',
      'Évaluer ses droits et obligations avant de signer et identifier les recours disponibles',
    ],
    programme: [
      {
        title: 'Module 1 — Le contrat : structure et types',
        duration: '3h',
        items: [
          'CDI, CDD, alternance, intérim',
          'Mentions obligatoires',
          'Hiérarchie des normes',
        ],
      },
      {
        title: 'Module 2 — Clauses essentielles',
        duration: '4h',
        items: [
          'Période d\'essai, rémunération, durée du travail',
          'Clauses sensibles : non-concurrence, mobilité',
          'Cas pratiques sur vrais contrats',
        ],
      },
      {
        title: 'Module 3 — Clauses à risque',
        duration: '4h',
        items: [
          'Repérer les clauses abusives',
          'Risques de requalification',
          'Bonnes pratiques de rédaction',
        ],
      },
      {
        title: 'Module 4 — Fiches mémo et synthèse',
        duration: '3h',
        items: [
          'Remise des fiches mémo opérationnelles',
          'Quiz et atelier de synthèse',
          'Plan d\'action personnel',
        ],
      },
    ],
    publicCible: [
      'Dirigeants TPE/PME',
      'Assistants RH',
      'Managers d\'équipe',
    ],
    prerequis: ['Aucun prérequis spécifique'],
  },
  {
    id: 'F10',
    code: 'F10',
    slug: 'comptabilite-non-comptables',
    emoji: '💰',
    domain: 'Gestion & Finance',
    title: 'Comptabilité pour non-comptables',
    description:
      'Démystifiez la comptabilité et lisez vos états financiers avec assurance.',
    duration: '21h / 3j',
    hours: 21,
    price: 690,
    oldPrice: null,
    modality: 'Mixte',
    groupSize: '6-15 pers.',
    badge: null,
    featured: false,
    image:
      'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80',
    points: [
      'Lire et interpréter bilan et compte de résultat',
      'Calcul des ratios financiers',
      'Tableau de bord financier sur tableur',
    ],
    objectifs: [
      'Comprendre la logique comptable et les écritures',
      'Lire un bilan et un compte de résultat',
      'Calculer les principaux ratios de gestion',
      'Construire un tableau de bord financier simple',
      'Dialoguer efficacement avec votre expert-comptable',
    ],
    competences: [
      'Expliquer les principes fondamentaux de la comptabilité générale et leur utilité pour le dirigeant',
      'Lire et interpréter un bilan comptable (actif, passif, fonds de roulement, trésorerie nette)',
      'Analyser un compte de résultat et calculer les soldes intermédiaires de gestion (SIG)',
      'Calculer les principaux ratios de rentabilité, liquidité et solvabilité',
      'Construire un tableau de bord financier simplifié pour piloter son activité au quotidien',
    ],
    programme: [
      {
        title: 'Module 1 — Logique comptable',
        duration: '5h',
        items: [
          'Principes : partie double, débit/crédit',
          'Plan comptable et écritures de base',
          'Cycle d\'exploitation',
        ],
      },
      {
        title: 'Module 2 — Compte de résultat',
        duration: '5h',
        items: [
          'Produits et charges',
          'Soldes intermédiaires de gestion',
          'Atelier de lecture',
        ],
      },
      {
        title: 'Module 3 — Bilan et équilibres',
        duration: '6h',
        items: [
          'Actif, passif, capitaux propres',
          'Besoin en fonds de roulement, trésorerie',
          'Ratios financiers clés',
        ],
      },
      {
        title: 'Module 4 — Tableau de bord',
        duration: '5h',
        items: [
          'Indicateurs de pilotage',
          'Construction sur tableur',
          'Lecture mensuelle et décisions',
        ],
      },
    ],
    publicCible: [
      'Dirigeants non-financiers',
      'Managers et chefs de projet',
      'Créateurs d\'entreprise',
    ],
    prerequis: ['Aucun prérequis spécifique'],
  },
  {
    id: 'F11',
    code: 'F11',
    slug: 'bases-gestion-createurs-entreprise',
    emoji: '🚀',
    domain: 'Gestion & Entrepreneuriat',
    title: "Bases de gestion pour créateurs d'entreprise",
    description:
      'Pilotez votre projet de création avec des outils de gestion concrets et adaptés.',
    duration: '21h / 3j',
    hours: 21,
    price: 590,
    oldPrice: null,
    modality: 'Mixte',
    groupSize: '6-15 pers.',
    badge: null,
    featured: false,
    image:
      'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80',
    points: [
      'Prévisionnel financier sur 3 ans',
      'Calcul du seuil de rentabilité',
      'Tableau de bord mensuel personnalisé',
    ],
    objectifs: [
      'Construire un business plan financier réaliste',
      'Établir un prévisionnel sur 3 ans',
      'Calculer un seuil de rentabilité',
      'Mettre en place un suivi de trésorerie',
      'Préparer un dossier de financement',
    ],
    competences: [
      'Expliquer les fondamentaux de la gestion d\'entreprise et distinguer résultat et trésorerie',
      'Construire un prévisionnel financier (compte de résultat et plan de trésorerie) sur 3 ans',
      'Calculer le seuil de rentabilité et le point mort de son projet',
      'Mettre en place un tableau de bord mensuel avec les indicateurs adaptés à son activité',
      'Évaluer les risques financiers de son projet et identifier les signaux d\'alerte',
    ],
    programme: [
      {
        title: 'Module 1 — Du projet au business plan',
        duration: '5h',
        items: [
          'Modèle économique et proposition de valeur',
          'Étude de marché synthétique',
          'Hypothèses de chiffre d\'affaires',
        ],
      },
      {
        title: 'Module 2 — Prévisionnel financier',
        duration: '6h',
        items: [
          'Compte de résultat prévisionnel à 3 ans',
          'Plan de financement initial',
          'Plan de trésorerie mensuel',
        ],
      },
      {
        title: 'Module 3 — Pilotage opérationnel',
        duration: '5h',
        items: [
          'Seuil de rentabilité et point mort',
          'Marge brute, EBE, capacité d\'autofinancement',
          'Tableau de bord mensuel',
        ],
      },
      {
        title: 'Module 4 — Financer son projet',
        duration: '5h',
        items: [
          'Banques, BPI, microcrédit, aides régionales',
          'Pitch financier en 10 slides',
          'Préparer un rendez-vous bancaire',
        ],
      },
    ],
    publicCible: [
      'Porteurs de projet',
      'Demandeurs d\'emploi en création',
      'Salariés en reconversion entrepreneuriale',
    ],
    prerequis: ['Projet de création identifié, aisance avec un tableur'],
  },
  {
    id: 'F12',
    code: 'F12',
    slug: 'droit-social-tpe-pme',
    emoji: '👥',
    domain: 'Droit social & RH',
    title: 'Droit social pour TPE et PME',
    description:
      'Sécurisez la gestion sociale de votre entreprise et anticipez les évolutions réglementaires.',
    duration: '21h / 3j',
    hours: 21,
    price: 690,
    oldPrice: null,
    modality: 'Mixte',
    groupSize: '6-15 pers.',
    badge: null,
    featured: false,
    image:
      'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800&q=80',
    points: [
      'Obligations légales employeur',
      'Procédure rupture conventionnelle simulée',
      'Gestion absences et congés payés',
    ],
    objectifs: [
      'Maîtriser les obligations sociales de l\'employeur',
      'Sécuriser les procédures de rupture',
      'Gérer les absences et congés payés',
      'Anticiper les risques sociaux et prud\'homaux',
      'Dialoguer sereinement avec les salariés',
    ],
    competences: [
      'Identifier les obligations légales de l\'employeur (affichage, registres, déclarations sociales)',
      'Rédiger un contrat de travail conforme et sécuriser la période d\'essai',
      'Appliquer les règles de gestion des congés payés, arrêts maladie et absences',
      'Conduire une procédure de rupture conventionnelle ou de licenciement dans le respect du droit',
      'Évaluer les risques de contentieux prud\'homal et mettre en place des mesures préventives',
    ],
    programme: [
      {
        title: 'Module 1 — Cadre du droit social',
        duration: '5h',
        items: [
          'Sources du droit du travail',
          'Convention collective applicable',
          'Documents obligatoires (DUERP, affichages)',
        ],
      },
      {
        title: 'Module 2 — Vie du salarié',
        duration: '5h',
        items: [
          'Temps de travail, heures supplémentaires',
          'Absences, maladie, congés payés',
          'Discipline et sanctions',
        ],
      },
      {
        title: 'Module 3 — Rupture du contrat',
        duration: '6h',
        items: [
          'Rupture conventionnelle pas à pas',
          'Licenciement personnel et économique',
          'Documents de fin de contrat',
        ],
      },
      {
        title: 'Module 4 — Prévention des risques',
        duration: '5h',
        items: [
          'Risques prud\'homaux et bonnes pratiques',
          'Inspection du travail et contrôles URSSAF',
          'Plan de mise en conformité',
        ],
      },
    ],
    publicCible: [
      'Dirigeants TPE/PME',
      'Responsables et assistants RH',
      'Encadrants',
    ],
    prerequis: ['Aucun prérequis spécifique'],
  },
  {
    id: 'F13',
    code: 'F13',
    slug: 'maitriser-ia-entreprise',
    emoji: '🧠',
    domain: 'Intelligence Artificielle & Productivité',
    title: "Maîtriser les outils d'intelligence artificielle en entreprise",
    description:
      "Intégrez ChatGPT, Claude, Gemini et l'automatisation no-code dans votre activité — sans compétence technique préalable.",
    duration: '21h / 3j',
    hours: 21,
    price: 690,
    oldPrice: null,
    modality: 'Distanciel',
    groupSize: '6-15 pers.',
    badge: '⚡ TRÈS DEMANDÉE 2026',
    featured: false,
    image:
      'https://images.unsplash.com/photo-1677442135703-1787eea5ce01?w=800&q=80',
    points: [
      'ChatGPT, Claude, Gemini maîtrisés',
      'Automatisation no-code (Zapier, Make)',
      'Plan déploiement IA 90 jours',
    ],
    objectifs: [
      "Comprendre les mécanismes fondamentaux de l'intelligence artificielle générative",
      "Identifier et sélectionner les outils IA adaptés à son secteur d'activité",
      "Rédiger des prompts efficaces pour obtenir des résultats professionnels de qualité",
      "Automatiser des tâches répétitives grâce aux outils no-code intégrant l'IA",
      "Évaluer les risques éthiques, juridiques et de confidentialité liés à l'usage de l'IA",
      "Construire un plan de déploiement IA concret pour son activité sur 90 jours",
    ],
    competences: [
      'Expliquer le fonctionnement des LLMs et identifier les familles d\'outils IA disponibles en 2026',
      'Utiliser les assistants IA avec des techniques de prompting avancées adaptées à son métier',
      'Créer des workflows automatisés intégrant l\'IA dans ses processus professionnels',
      'Produire des contenus professionnels assistés par l\'IA (textes, visuels, présentations)',
      'Construire et présenter un plan de déploiement IA concret pour son activité sur 90 jours',
    ],
    programme: [
      {
        title: "Module 1 — L'IA en entreprise en 2026 : panorama et enjeux",
        duration: '4h',
        items: [
          'Histoire de l\'IA et révolution des LLMs (Large Language Models)',
          'Les grandes familles d\'outils : texte, image, voix, vidéo, code',
          'Ce que l\'IA change vraiment pour votre métier',
          'Le règlement européen AI Act : ce qu\'il faut savoir',
          'Cas d\'usage concrets par secteur d\'activité',
        ],
      },
      {
        title: 'Module 2 — Maîtriser les assistants IA : ChatGPT, Claude, Gemini, Copilot',
        duration: '5h',
        items: [
          'Comparatif des 4 grands assistants IA du marché',
          'L\'art du prompting : zero-shot, few-shot, chain-of-thought',
          'Construire des prompts métier efficaces pour son activité',
          'Gérer les hallucinations et vérifier les sorties de l\'IA',
          'Confidentialité des données : bonnes pratiques professionnelles',
        ],
      },
      {
        title: 'Module 3 — IA pour créer du contenu et gagner en productivité',
        duration: '5h',
        items: [
          'Rédaction assistée : e-mails, rapports, fiches produits, devis',
          'Génération d\'images professionnelles : Midjourney, DALL-E, Adobe Firefly',
          'Création de présentations avec l\'IA (Gamma, Beautiful.ai, Canva IA)',
          'Transcription et synthèse de réunions (Otter.ai, Notion AI)',
          'Droits d\'auteur et propriété intellectuelle des créations IA',
        ],
      },
      {
        title: 'Module 4 — Automatisation no-code et intégration dans ses outils',
        duration: '4h',
        items: [
          'Zapier, Make (Integromat), n8n : créer des automatisations IA',
          'Intégrer l\'IA dans son CRM, sa messagerie, ses tableurs',
          'Créer son propre assistant IA personnalisé (GPTs, Claude Projects)',
          'Mesurer le gain de productivité et le ROI de ses déploiements IA',
        ],
      },
      {
        title: "Module 5 — Plan d'action et déploiement dans son entreprise",
        duration: '3h',
        items: [
          'Cartographier les tâches automatisables dans son activité',
          'Construire son plan de déploiement IA en 90 jours',
          'Former ses collaborateurs : accompagnement au changement',
          'Évaluation finale : présentation du plan de déploiement IA',
        ],
      },
    ],
    publicCible: [
      "Dirigeants d'entreprise et managers",
      'Chefs de projet et responsables marketing',
      'Assistants de direction',
      "Tout professionnel souhaitant intégrer l'IA",
    ],
    prerequis: [
      'Maîtrise de base d\'internet et des outils bureautiques',
      'Aucun prérequis en programmation ou IA',
    ],
  },
  {
    id: 'F14',
    code: 'F14',
    slug: 'creer-activite-business-en-ligne',
    emoji: '🚀',
    domain: 'Entrepreneuriat & Business Digital',
    title: 'Créer son activité et développer son business en ligne',
    description:
      "De l'idée au premier client en 4 jours : site web, réseaux sociaux, paiement Stripe, business model et prévisionnel inclus.",
    duration: '28h / 4j',
    hours: 28,
    price: 790,
    oldPrice: null,
    modality: 'Distanciel',
    groupSize: '6-12 pers.',
    badge: '🔥 BEST-SELLER',
    featured: false,
    image:
      'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80',
    points: [
      'De l\'idée au premier client en 4 jours',
      'Site web, réseaux sociaux, Stripe',
      'Business model et prévisionnel inclus',
    ],
    objectifs: [
      "Valider la viabilité de son projet d'activité en ligne avec une méthode structurée",
      'Construire un business model solide et un prévisionnel financier réaliste',
      'Créer une présence en ligne professionnelle (site, réseaux, landing page)',
      'Maîtriser les outils de vente et de paiement en ligne (Stripe, Systeme.io)',
      'Acquérir ses premiers clients grâce au marketing digital et au bouche-à-oreille structuré',
      'Gérer les aspects juridiques, fiscaux et administratifs de son activité en ligne',
    ],
    competences: [
      'Analyser la viabilité de son projet d\'activité en ligne avec la méthode Lean Canvas',
      'Concevoir un business model rentable et un prévisionnel financier sur 3 ans',
      'Créer un site web professionnel et configurer un système de paiement en ligne (Stripe)',
      'Mettre en œuvre une stratégie d\'acquisition des premiers clients (SEO, réseaux, bouche-à-oreille)',
      'Évaluer la performance de son activité et ajuster sa stratégie selon les données',
    ],
    programme: [
      {
        title: 'Module 1 — Valider son idée et construire son business model',
        duration: '6h',
        items: [
          'Business models du digital : services, formation, e-commerce, affiliation, SaaS',
          'Méthode lean canvas : valider son idée en 2 heures',
          'Identifier sa cible, ses concurrents et son positionnement unique',
          'Construction du business model canvas personnalisé',
          'Prévisionnel financier simplifié : CA prévisionnel et seuil de rentabilité',
          'Atelier : pitch de son projet en 3 minutes',
        ],
      },
      {
        title: 'Module 2 — Créer sa présence en ligne professionnelle',
        duration: '7h',
        items: [
          'Site web sans coder : Webflow, Wix, Squarespace, Systeme.io comparés',
          'Rédiger des pages qui convertissent : accueil, offre, à propos, contact',
          'SEO de base : apparaître sur Google sans budget publicitaire',
          'Identité visuelle avec Canva (logo, couleurs, visuels)',
          'Configurer ses réseaux sociaux professionnels (LinkedIn, Instagram, Facebook)',
          'Atelier guidé : création de son site et de ses profils sociaux',
        ],
      },
      {
        title: 'Module 3 — Vendre en ligne et encaisser ses premiers paiements',
        duration: '8h',
        items: [
          'Créer ses offres de service : forfaits, à la carte, abonnement',
          'Stripe, PayPal, SumUp : configurer son système de paiement en ligne',
          'Tunnels de vente simplifiés : landing page → formulaire → paiement',
          'E-mail marketing : créer sa liste et automatiser ses relances (Mailchimp, Brevo)',
          'Créer son premier programme de formation ou e-book à vendre en ligne',
          'Atelier : mise en ligne de sa première offre avec bouton de paiement',
        ],
      },
      {
        title: 'Module 4 — Acquérir ses premiers clients et développer son activité',
        duration: '7h',
        items: [
          'Marketing de contenu : créer des publications qui attirent des clients',
          'LinkedIn pour les indépendants : prospecter sans forcer',
          'Bouche-à-oreille structuré : programme de parrainage et recommandations',
          'Publicité digitale low-cost : Facebook Ads et Google Ads pour débuter',
          'Fidéliser et faire racheter : newsletter, offres exclusives, suivi client',
          'Atelier final : plan d\'action des 30 premiers jours pour acquérir ses 5 premiers clients',
        ],
      },
    ],
    publicCible: [
      'Porteurs de projet activité en ligne',
      'Demandeurs d\'emploi en reconversion entrepreneuriale',
      'Auto-entrepreneurs débutants',
      'Salariés souhaitant développer une activité complémentaire',
      'Créateurs de contenu souhaitant monétiser leur expertise',
    ],
    prerequis: [
      'Avoir un projet ou une idée d\'activité',
      'Maîtrise de base d\'internet',
      'Aucun prérequis technique ou commercial',
    ],
  },
  {
    id: 'F15',
    code: 'F15',
    slug: 'communication-digitale-reseaux-sociaux',
    emoji: '📣',
    domain: 'Communication & Marketing Digital',
    title: 'Communication digitale et réseaux sociaux professionnels',
    description:
      "Stratégie LinkedIn, Instagram, Facebook maîtrisée. Création de contenus avec Canva et calendrier éditorial 3 mois inclus.",
    duration: '21h / 3j',
    hours: 21,
    price: 590,
    oldPrice: null,
    modality: 'Distanciel',
    groupSize: '6-15 pers.',
    badge: null,
    featured: false,
    image:
      'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=800&q=80',
    points: [
      'Stratégie LinkedIn, Instagram, Facebook maîtrisée',
      'Création de contenus professionnels avec Canva',
      'Calendrier éditorial 3 mois inclus',
    ],
    objectifs: [
      'Construire une stratégie de communication digitale cohérente et adaptée à sa cible',
      'Maîtriser les spécificités et codes de chaque réseau social professionnel',
      'Créer des contenus visuels professionnels avec Canva sans compétence graphique',
      'Planifier et animer sa communication avec un calendrier éditorial sur 3 mois',
      'Analyser ses performances et adapter sa stratégie grâce aux statistiques',
      'Gérer sa réputation en ligne et répondre aux situations de crise digitale',
    ],
    competences: [
      'Analyser sa présence digitale actuelle et identifier les canaux les plus pertinents pour sa cible',
      'Concevoir une stratégie de communication digitale avec une ligne éditoriale cohérente',
      'Créer des contenus visuels professionnels (posts, stories, reels, carrousels) avec Canva',
      'Animer une communauté professionnelle sur LinkedIn, Instagram et Facebook',
      'Évaluer ses performances via les statistiques et adapter sa stratégie éditoriale',
    ],
    programme: [
      {
        title: 'Module 1 — Stratégie digitale : se positionner et trouver sa voix',
        duration: '4h',
        items: [
          'Audit de sa présence digitale actuelle (forces et axes d\'amélioration)',
          'Définir sa cible idéale : le persona et ses habitudes numériques',
          'Les 4 grands réseaux : LinkedIn, Instagram, Facebook, TikTok — forces et usages pro',
          'Choisir les bons canaux selon son activité et ses ressources',
          'Définir sa ligne éditoriale : ton, thèmes, fréquence, style visuel',
          'Atelier : construction de son persona et de sa ligne éditoriale',
        ],
      },
      {
        title: 'Module 2 — Créer des contenus professionnels qui engagent',
        duration: '5h',
        items: [
          'Types de contenus qui fonctionnent : éducatif, inspirant, promotionnel, conversationnel',
          'Canva maîtrisé : templates pro, charte graphique, tailles par réseau',
          'Rédiger des légendes et des accroches qui captent l\'attention',
          'Créer des visuels, carrousels, stories et vidéos courtes',
          'L\'IA au service de la création de contenu : ChatGPT, Canva IA, Capcut',
          'Atelier : création de 10 contenus prêts à publier pour son activité',
        ],
      },
      {
        title: 'Module 3 — LinkedIn, Instagram et Facebook : maîtriser chaque réseau',
        duration: '6h',
        items: [
          'LinkedIn pour les pros : optimiser son profil, publier, prospecter, réseauter',
          'Instagram Business : reels, stories, carrousels, hashtags et algorithme',
          'Facebook : page pro, groupes, événements et publicités de base',
          'Planification et automatisation : Buffer, Later, Meta Business Suite',
          'Community management : répondre aux commentaires, gérer les messages',
          'Atelier : optimisation complète de ses profils professionnels',
        ],
      },
      {
        title: 'Module 4 — Analyser, ajuster et gérer sa e-réputation',
        duration: '3h',
        items: [
          'Lire et interpréter ses statistiques : portée, engagement, clics, conversions',
          'KPIs essentiels à suivre chaque semaine',
          'Ajuster sa stratégie selon les données (ce qui fonctionne, ce qui ne fonctionne pas)',
          'Gérer sa réputation en ligne : avis Google, commentaires négatifs, crise digitale',
          'Atelier final : construction de son calendrier éditorial 3 mois + tableau de bord',
        ],
      },
    ],
    publicCible: [
      'Chefs d\'entreprise et indépendants',
      'Responsables communication de TPE/PME',
      'Assistants marketing',
      'Demandeurs d\'emploi en reconversion digitale',
      'Community managers débutants',
    ],
    prerequis: [
      'Utiliser quotidiennement internet et les réseaux sociaux',
      'Avoir un smartphone et un ordinateur',
      'Aucune compétence technique préalable',
    ],
  },
  {
    id: 'F16',
    code: 'F16',
    slug: 'pack-dissertation-management-strategique',
    emoji: '🎓',
    domain: 'Management Stratégique & Concours',
    title: 'Pack Dissertation Management Stratégique',
    description:
      "Méthodologie, 10 dissertations rédigées, 10 plans approfondis, 6 auteurs majeurs et 20 sujets prioritaires : tout pour réussir la dissertation de management stratégique aux concours et à l'agrégation.",
    duration: 'Auto-formation',
    hours: 0,
    price: 990,
    oldPrice: null,
    modality: 'Distanciel',
    groupSize: 'Accès individuel',
    badge: '🎯 CONCOURS & AGRÉGATION',
    featured: false,
    image:
      'https://images.unsplash.com/photo-1532012197267-da84d127e765?w=800&q=80',
    points: [
      'Méthodologie complète de la dissertation : mise en tension, problématique, plan dialectique',
      '10 dissertations entièrement rédigées (textes de fond, niveau agrégation) + 10 sujets avec plans approfondis',
      '6 auteurs majeurs expliqués : Schumpeter, Drucker, Mintzberg, Crozier, Castel, Argyris & Schön',
    ],
    objectifs: [
      'Maîtriser la méthodologie de la dissertation de management stratégique attendue aux concours',
      'Construire une mise en tension, une problématique et un plan dialectique en 3 parties',
      'Mobiliser les 6 auteurs majeurs et les outils stratégiques (SWOT, PESTEL, Porter, VRIO, BCG, Ansoff) dans une copie',
      'Disposer de 10 dissertations rédigées et de 10 plans approfondis comme modèles de référence',
      'Préparer efficacement les épreuves grâce à 20 sujets prioritaires commentés et des quiz corrigés',
    ],
    competences: [
      'Analyser un sujet de dissertation et en dégager une problématique de niveau concours et agrégation',
      'Rédiger un plan dialectique en 3 parties avec transitions argumentées',
      "Expliquer et mobiliser les apports de Schumpeter, Drucker, Mintzberg, Crozier, Castel et Argyris & Schön avec des exemples d'entreprises réelles",
      'Utiliser les outils SWOT, PESTEL, Porter, VRIO, BCG et Ansoff dans une analyse stratégique',
      'Anticiper les sujets probables et organiser ses révisions à partir de 20 sujets prioritaires',
    ],
    programme: [
      {
        title: 'Module 1 — Méthodologie de la dissertation de management stratégique',
        duration: 'Inclus dans le pack',
        items: [
          'Comprendre et délimiter le sujet',
          'Construire la mise en tension et la problématique',
          'Bâtir le plan dialectique en 3 parties (I / II / III)',
          'Structure des corrigés : introduction, transitions, conclusion',
          'Mobiliser les outils stratégiques (SWOT, PESTEL, Porter, VRIO, BCG, Ansoff)',
        ],
      },
      {
        title: 'Module 2 — 10 sujets prioritaires : problématiques et plans approfondis',
        duration: 'Inclus dans le pack',
        items: [
          '10 sujets de concours analysés',
          'Problématique rédigée pour chaque sujet',
          'Plan dialectique détaillé (I / II / III) avec sous-parties',
          'Auteurs et outils à mobiliser pour chaque sujet',
        ],
      },
      {
        title: 'Module 3 — 10 dissertations rédigées (textes de fond)',
        duration: 'Inclus dans le pack',
        items: [
          '10 dissertations intégralement rédigées, niveau agrégation',
          'Introductions, transitions et conclusions rédigées',
          'Références aux auteurs et cas d\'entreprises (Apple, Tesla, Amazon, Toyota, Netflix)',
          'Points de vigilance du jury',
        ],
      },
      {
        title: 'Module 4 — Les 6 auteurs majeurs',
        duration: 'Inclus dans le pack',
        items: [
          'Schumpeter — innovation et destruction créatrice',
          'Drucker — management par objectifs et performance',
          'Mintzberg — configurations organisationnelles et stratégie émergente',
          'Crozier — analyse stratégique des organisations et pouvoir',
          'Castel — transformations du travail et du salariat',
          'Argyris & Schön — apprentissage organisationnel (simple et double boucle)',
        ],
      },
      {
        title: 'Module 5 — 20 sujets prioritaires commentés et quiz',
        duration: 'Inclus dans le pack',
        items: [
          '20 sujets prioritaires commentés : axes de réflexion, pièges, auteurs à citer',
          'Quiz interactifs par module avec corrigés détaillés',
          'Quiz final de validation (seuil 80 %) et certificat de réalisation',
        ],
      },
    ],
    inclusions: [
      'Méthodologie complète + structure des corrigés (PDF)',
      '10 sujets prioritaires avec problématiques et plans approfondis (PDF)',
      '10 dissertations rédigées — textes de fond niveau agrégation (PDF)',
      'Document « 6 auteurs majeurs » : Schumpeter, Drucker, Mintzberg, Crozier, Castel, Argyris & Schön (PDF)',
      '20 sujets prioritaires commentés (PDF)',
      'Quiz interactifs par module + quiz final, corrigés détaillés (espace apprenant + PDF)',
      'Cas Apple · Tesla · Amazon · Toyota · Netflix',
      'Accès immédiat et illimité dans l\'espace apprenant après paiement',
      'Certificat de réalisation MGB School',
    ],
    modalitesEvaluation: [
      'Quiz de positionnement avant la formation',
      'Quiz formatifs à la fin de chaque module',
      "Étude de cas finale : analyser un sujet et rédiger un plan complet avec problématique",
      'Questionnaire de satisfaction',
    ],
    ctaLabel: '💳 Acheter maintenant',
    showFinancementBox: true,
    publicCible: [
      'Étudiants préparant un concours de management',
      'Agrégation',
      'Masters',
      'BTS',
      'Grandes écoles',
      'Enseignants',
    ],
    prerequis: ['Aucun — accessible du lycée à l\'agrégation'],
  },
  {
    id: 'OTM-PACK',
    code: 'OTM-PACK',
    slug: 'pack-bac-pro-otm',
    emoji: '🚛',
    domain: 'Transport & Logistique',
    title: 'Pack Bac Pro OTM – Organisation de Transport de Marchandises',
    subtitle: '8 modules + 6 bonus – Accès immédiat – Self-service',
    description:
      "Formez-vous aux compétences du Bac Pro OTM avec un pack complet, opérationnel et conforme au référentiel de l'Éducation nationale. Idéal pour les élèves, les alternants, les personnes en reconversion ou les professionnels qui veulent consolider leurs bases.",
    longDescription:
      "Le Pack OTM MGB School vous donne les outils concrets pour maîtriser l'organisation des transports de marchandises (routier, maritime, aérien, multimodal) et réussir vos épreuves ou votre prise de poste.",
    duration: 'Auto-formation',
    hours: 0,
    price: 299,
    oldPrice: null,
    modality: 'Distanciel',
    groupSize: 'Accès individuel',
    badge: '🎓 BAC PRO OTM',
    featured: false,
    image:
      'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&q=80',
    points: [
      '8 modules complets avec quiz d\'auto-évaluation et corrigés',
      '6 bonus : documents pro types, fiches mémo, exercices type examen, simulations, emploi & alternance, méthodologie',
      '100 % conforme au référentiel officiel du Bac Pro OTM — accès immédiat après paiement',
    ],
    objectifs: [
      "Maîtriser l'organisation des transports de marchandises : routier, maritime, aérien, ferroviaire et multimodal",
      'Établir et contrôler les documents de transport et de douane (CMR, B/L, AWB, facture, packing list, Incoterms)',
      'Comprendre la supply chain, les outils numériques (TMS, WMS) et les indicateurs de performance',
      'Se préparer aux épreuves du Bac Pro OTM avec des exercices corrigés type examen et des simulations',
      "Structurer ses connaissances pour une prise de poste d'agent d'exploitation transport",
    ],
    competences: [
      'Organiser une opération de transport routier, maritime, aérien ou multimodal de bout en bout',
      'Renseigner et vérifier les documents professionnels du transport international',
      'Appliquer les Incoterms et les formalités douanières à une opération import/export',
      'Utiliser un TMS / WMS et construire un tableau de bord de performance logistique',
      "Résoudre des cas pratiques et des exercices type examen Bac Pro OTM",
    ],
    programme: [
      { title: 'Module 1 — Transport Routier', duration: 'Inclus dans le pack', items: ['Réglementation, temps de conduite et acteurs du transport routier', 'Lettre de voiture CMR et documents de bord', 'Organisation d\'une tournée et calcul de coûts', 'Quiz d\'auto-évaluation + corrigé'] },
      { title: 'Module 2 — Transport Maritime', duration: 'Inclus dans le pack', items: ['Conteneurisation, lignes régulières et acteurs portuaires', 'Bill of Lading, booking, packing list', 'Incoterms maritimes et cas pratique import', 'Quiz d\'auto-évaluation + corrigé'] },
      { title: 'Module 3 — Transport Aérien', duration: 'Inclus dans le pack', items: ['Fret aérien : acteurs, aéroports, sûreté', 'Air Waybill (AWB) et poids taxable', 'Marchandises dangereuses et délais', 'Quiz d\'auto-évaluation + corrigé'] },
      { title: 'Module 4 — Ferroviaire, Multimodal & International', duration: 'Inclus dans le pack', items: ['Transport ferroviaire et combiné rail-route', 'Chaînes multimodales et choix du mode', 'Opérations internationales et interlocuteurs', 'Quiz d\'auto-évaluation + corrigé'] },
      { title: 'Module 5 — Supply Chain & Logistique', duration: 'Inclus dans le pack', items: ['Flux physiques et d\'information, stocks et entrepôts', 'Préparation de commandes et distribution', 'Logistique moderne : e-commerce, dernier kilomètre', 'Quiz d\'auto-évaluation + corrigé'] },
      { title: 'Module 6 — Douane, Incoterms & Documents', duration: 'Inclus dans le pack', items: ['Incoterms 2020 : répartition des coûts et des risques', 'Formalités douanières, DAU, origine, valeur en douane', 'Facture export, certificats, documents d\'accompagnement', 'Quiz d\'auto-évaluation + corrigé'] },
      { title: 'Module 7 — TMS / WMS & Outils numériques', duration: 'Inclus dans le pack', items: ['Fonctions d\'un TMS et d\'un WMS', 'Traçabilité, EDI, géolocalisation', 'Outils bureautiques de l\'agent d\'exploitation', 'Quiz d\'auto-évaluation + corrigé'] },
      { title: 'Module 8 — Amélioration de la performance & tableaux de bord', duration: 'Inclus dans le pack', items: ['Indicateurs de performance transport et logistique (KPI)', 'Construire et analyser un tableau de bord', 'Démarche d\'amélioration continue et qualité de service', 'Quiz d\'auto-évaluation + corrigé'] },
    ],
    inclusions: [
      '8 modules complets avec quiz d\'auto-évaluation et corrigés (PDF + espace apprenant)',
      'Bonus 1 — Documents professionnels types (CMR, B/L, AWB, facture, packing list…)',
      'Bonus 2 — Fiches mémo & révision rapide',
      'Bonus 3 — Emploi & Alternance',
      'Bonus 4 — Exercices corrigés type examen',
      'Bonus 5 — Simulations agent d\'exploitation',
      'Bonus 6 — Guide méthodologie examen',
      'Accès immédiat et illimité — ordinateur, tablette et mobile',
      'Certificat de réalisation MGB School',
    ],
    modalitesEvaluation: [
      'Quiz d\'auto-évaluation corrigé à la fin de chaque module',
      'Exercices corrigés type examen Bac Pro OTM',
      'Quiz final de validation (seuil 80 %) → certificat de réalisation',
      'Questionnaire de satisfaction',
    ],
    ctaLabel: '💳 Acheter maintenant',
    showFinancementBox: false,
    publicCible: [
      'Élèves de Bac Pro OTM',
      'Alternants transport & logistique',
      'Adultes en reconversion',
      'Salariés du transport et de la logistique souhaitant structurer leurs connaissances',
    ],
    prerequis: ['Aucun prérequis — accessible dès la seconde professionnelle'],
  },
];

// ===============================================================
// Slides preview — 4 mini-slides par formation pour la section
// "Aperçu des slides" (page détail formation)
// ===============================================================
const SLIDES_PREVIEW = {
  F01: [
    "Qu'est-ce que la SWOT ?",
    "Forces · Faiblesses · Opportunités · Menaces",
    "Cas Apple · Cas Tesla · Cas Amazon",
    "Quiz SWOT · 20 questions corrigées",
  ],
  F02: [
    "Panorama du marketing digital 2026",
    "Canva · Meta Business · Google My Business",
    "Cas concrets TPE · Calendrier éditorial",
    "Quiz marketing · KPIs essentiels",
  ],
  F03: [
    "Shopify vs WooCommerce vs Wix",
    "Fiches produits SEO · Photographie",
    "Cas Vinted · Cas Amazon · Cas Cdiscount",
    "Quiz e-commerce · Checklist lancement",
  ],
  F04: [
    "Le régime microentrepreneur en détail",
    "URSSAF · Déclarations · Cotisations",
    "Cas pratiques · Seuils 2026 · Facturation",
    "Quiz administratif · 20 questions",
  ],
  F05: [
    "Les types de contrats : CDI · CDD · Intérim",
    "Clauses essentielles et clauses à risque",
    "Cas réels anonymisés · Analyse guidée",
    "Quiz juridique · 20 questions corrigées",
  ],
  F06: [
    "Les codes de la communication digitale",
    "Teams · Slack · Google Workspace",
    "Cas e-mails professionnels corrigés",
    "Quiz communication · LinkedIn optimisé",
  ],
  F07: [
    "ABC · FIFO · LIFO · CMUP",
    "Stock de sécurité · Point de commande",
    "Cas entrepôt · Tableau de bord KPI",
    "Quiz logistique · 20 questions",
  ],
  F08: [
    "ChatGPT · Claude · Gemini · Copilot",
    "Techniques de prompting avancées",
    "Cas automatisation · Zapier · Make",
    "Quiz IA · Plan déploiement 90 jours",
  ],
  F09: [
    "Les mentions obligatoires décryptées",
    "Clause non-concurrence · Mobilité",
    "Cas contrats réels annotés",
    "Quiz contrat · 20 questions corrigées",
  ],
  F10: [
    "Lire un bilan · Actif vs Passif",
    "Compte de résultat · SIG · Marges",
    "Cas TPE réelle anonymisée",
    "Quiz comptabilité · Ratios financiers",
  ],
  F11: [
    "Prévisionnel financier sur 3 ans",
    "Seuil de rentabilité · Point mort",
    "Cas créateur · Tableau de bord mensuel",
    "Quiz gestion · 20 questions",
  ],
  F12: [
    "Obligations légales de l'employeur",
    "Congés payés · Arrêts maladie · Contrats",
    "Cas rupture conventionnelle simulée",
    "Quiz droit social · 20 questions",
  ],
  F13: [
    "L'IA en entreprise en 2026 · Panorama",
    "Prompting avancé · LLMs comparés",
    "Cas Apple · Tesla · Amazon et l'IA",
    "Quiz IA · Plan déploiement 90 jours",
  ],
  F14: [
    "Lean Canvas · Valider son idée",
    "Site web sans coder · Stripe · Paiement",
    "Cas entrepreneurs · Premiers clients",
    "Quiz business · Plan 30 jours",
  ],
  F15: [
    "LinkedIn · Instagram · Facebook · TikTok",
    "Canva IA · Calendrier éditorial 3 mois",
    "Cas community managers · Résultats réels",
    "Quiz réseaux sociaux · KPIs",
  ],
  F16: [
    "Mise en tension · Problématique · Plan I/II/III",
    "10 dissertations rédigées · 10 plans approfondis",
    "Schumpeter · Drucker · Mintzberg · Crozier · Castel · Argyris & Schön",
    "20 sujets prioritaires · Quiz corrigés",
  ],
  'OTM-PACK': [
    "Routier · Maritime · Aérien · Multimodal",
    "CMR · B/L · AWB · Incoterms · Douane",
    "Supply chain · TMS / WMS · Tableaux de bord",
    "Quiz corrigés · Exercices type examen · Fiches mémo",
  ],
};


// ===============================================================
// Helper : retourne true si le lien Stripe n'est pas configuré
// ===============================================================
// ===============================================================
// Helper : récupère une formation par id ou slug
// ===============================================================
export const FORMATIONS = RAW_FORMATIONS.map((f) => ({
  ...f,
  slides: SLIDES_PREVIEW[f.id] || null,
  type: f.modality === 'Distanciel' ? 'selfservice' : 'presentiel',
}));

export const isSelfService = (f) => f?.type === 'selfservice';

export const getFormationById = (idOrSlug) =>
  FORMATIONS.find((f) => f.id === idOrSlug || f.slug === idOrSlug);
